const isImageMimeType = (mimeType) => {
  if (!mimeType) {
    return false;
  }

  return mimeType.startsWith('image/');
};

export default isImageMimeType;
